import baseSearch from './_base'

export default baseSearch({
  state: {
    filterset_name: 'mx_filter',
    _type: 'stock_item',
    mxfilter: undefined,
  },
  mutations: {
    setMxFilter(state, id) {
      state.mxfilter = id
    },
  },
  actions: {
    init({dispatch, state, commit}, {id}) {
      commit('setMxFilter', id)
      let init = dispatch('fetchFilterSet')
          .then(r => dispatch('fetchSearch'))
      commit('setInit', init)
      return init
    }
  }
})


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/search/mxcategory-items.js